<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].header }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative mb-5">
        <div class="w-full flex flex-column max-w-30rem relative surface-300 border-round-xl xl:border-round-2xl p-3 xl:p-4 mb-1 xl:mb-5">
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].account_number }}:
            </span>
            <span class="flex text-xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ account_number }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(account_number)"></span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].swift_code }}:
            </span>
            <span class="flex text-xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ swift_code }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(swift_code)"></span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].fullname }}:
            </span>
            <span class="flex text-sm xl:text-lg font-medium text-900 mb-3 xl:mb-4">
                <span>{{ fullname }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(fullname)"></span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].bank_name }}:
            </span>
            <span class="flex text-xs xl:text-lg font-medium text-900 mb-3 xl:mb-4">
                <span>{{ bank_name }}</span>
                <span class="pi pi-copy ml-3 text-500 text-lg cursor-pointer" @click="copy(bank_name)"></span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].address }}:
            </span>
            <span class="flex text-sm xl:text-lg font-medium text-900">
                {{ address }}
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(address)"></span>
            </span>
            <div class="absolute flex right-0 bottom-0 surface-0 mr-3 mb-3 overflow-hidden border-circle align-items-center justify-content-center text-center">
                <span class="w-full text-center h-3 w-3 p-3 xl:p-4">
                    <img :src="get_bank_image(bank_code)" class="w-full absolute left-0 top-0 p-2">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
export default {
    props: [
        'account_number',
        'swift_code',
        'fullname',
        'bank_name',
        'address',
        'bank_code'
    ],
	data(){
		return{
			content: {
				en: {
					header: 'As payment, make a transfer by details',
                    copied: 'Copied',
                    account_number: 'Account number',
                    swift_code: 'SWIFT code',
                    fullname: 'Full name',
                    bank_name: 'Bank name',
                    address: 'Address',
                    bank_code: 'Bank code',
				} ,
				ru: {
					header: 'В качестве оплаты совершите перевод по реквизитам',
                    copied: 'Скопировано',
                    account_number: 'Номер счета',
                    swift_code: 'SWIFT код',
                    fullname: 'Полное имя',
                    bank_name: 'Название банка',
                    address: 'Адрес',
                    bank_code: 'Код банка',
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        setUppercase(text){
            return text.toUpperCase()
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
	},
	beforeCreate() {
        this.helper = new Helper()    
	}
}
</script>